/* eslint-disable */
export default {
    error_page_not_found: "Seite nicht gefunden!",
    error_page_not_found_title: "Seite nicht gefunden",
    error_page_not_found_body: "Die von Ihnen angeforderte Seite konnte nicht gefunden werden.",
    error_ltpimpact_landing_title: "Dieser Service ist nicht länger verfügbar.",
    error_ltpimpact_landing_content: "Leider ist diese Seite nicht mehr zugänglich. Nehmen Sie Kontakt auf mit dem LTP-Kundencenter unter <a href=\"mailto:online@ltp.nl\">online@ltp.nl</a> oder unter +31 20 30 50 438."
};
